
import Button from '@/components/Button.vue'
export default {
  name: 'TPModal',
  components: {
    'tp-button': Button,
  },
}
